import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, finalize, Observable, of, switchMap } from 'rxjs';
import { VendorGroup } from '../models/vendor-group.model';
import { VendorGroupService } from '../services/vendor-group.service';
import { LoadingService } from 'src/app/core/ui/loading.service';

@Injectable({ providedIn: 'root' })
export class VendorGroupStore {
  private loadingService = inject(LoadingService);
  
  // Subjects für den Zustand
  private vendorGroupsSubject = new BehaviorSubject<VendorGroup[]>([]);

  // Öffentliche Observables
  vendorGroups$: Observable<VendorGroup[]> = this.vendorGroupsSubject.asObservable();

  constructor(private vendorGroupService: VendorGroupService) {}

  /**
   * Lädt alle VendorGroups und aktualisiert den Zustand.
   */
  loadVendorGroups(): Observable<VendorGroup[]> {
  this.loadingService.show();

  return this.vendorGroupService.fetchVendorGroups().pipe(
    switchMap((vendorGroups) => {
      this.vendorGroupsSubject.next(vendorGroups);
      return of(vendorGroups);
    }),
    finalize(() => {
      this.loadingService.hide();
    })
  );
}


  /**
   * Gibt die aktuelle Liste der VendorGroups zurück.
   */
  getVendorGroupsSnapshot(): VendorGroup[] {
    return this.vendorGroupsSubject.getValue();
  }

  /**
   * Gibt den Namen einer VendorGroup anhand der ID zurück.
   */
  getVendorGroupNameById(id: number): string | null {
    const vendorGroups = this.getVendorGroupsSnapshot();
    const vendorGroup = vendorGroups.find((group) => group.id === id);
    return vendorGroup ? vendorGroup.name : null;
  }
}